module.exports = __webpack_public_path__ + "static/media/settings.9ebfdd14.svg";